window.addEventListener('DOMContentLoaded', () => {
	const embedBlock = document.querySelector('.wp-block-embed.mavis-cookie-warning');
	if (!embedBlock) {
		return;
	}

	const loadVideoBtnWrapper = embedBlock.querySelector('.wp-block-button');
	const loadVideoBtn = loadVideoBtnWrapper.querySelector('button');

	/**
	 * Generates an iFrame for the YouTube video to be embedded and removes the button overlay.
	 * @param {Event} event Button click event.
	 */
	const loadYoutubeVideo = (event) => {
		event.preventDefault();
		const { embedUrl, embedTitle } = embedBlock.dataset;

		const iframe = document.createElement('iframe');
		iframe.setAttribute('src', embedUrl);
		iframe.setAttribute('title', embedTitle);
		iframe.setAttribute(
			'allow',
			'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
		);
		iframe.setAttribute('frameborder', 0);

		embedBlock.textContent = '';
		embedBlock.classList.add('is-loaded');
		embedBlock.appendChild(iframe);
	};

	loadVideoBtn.addEventListener('click', (e) => loadYoutubeVideo(e));
});
